import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class WidgetTable extends Component {
  static propTypes = {
    headerRow: PropTypes.object.isRequired,
    dataRows: PropTypes.array.isRequired,
    seeMoreUrl: PropTypes.string.isRequired,
  };

  render() {
    return (
      <div>
        <table className="widget-table">
          <thead>
            {this.props.headerRow}
          </thead>
          <tbody>
            {this.props.dataRows}
          </tbody>
        </table>
        <div className="widget-table-footer">
          <a href={this.props.seeMoreUrl}>See more</a>
        </div>
      </div>
    );
  }
}
